module.exports = __webpack_public_path__ + "static/media/amarant-mobile.f34fa43c.png";